import React, { memo } from 'react';
import { TrackGroup, TrackItem, TrackType } from '@monorepo/remotion-ninja';
import TrackItemComponent from './track-item';

interface TrackGroupProps {
  trackGroup: TrackGroup;
  trackId: string;
  isVisible: boolean;
  isLocked: boolean;
  totalFrames: number;
  zoomLevel: number;
  onItemClick?: (item: TrackItem) => void;
  onClick?: (e: React.MouseEvent) => void;
}

const TrackGroupComponent: React.FC<TrackGroupProps> = ({
  trackGroup,
  trackId,
  isVisible,
  isLocked,
  totalFrames,
  zoomLevel,
  onItemClick,
  onClick,
}) => {
  const trackType = trackGroup.type;

  return (
    <div
      className={`timeline-track ${trackType.toLowerCase()}-track ${
        isLocked ? 'locked' : ''
      } ${isVisible ? '' : 'hidden'}`}
      onClick={onClick}
    >
      {/* Render track items */}
      {trackGroup.tracks.map((item, itemIndex) => (
        <TrackItemComponent
          key={`${trackId}-item-${itemIndex}`}
          item={item}
          trackType={item.type || trackType}
          totalFrames={totalFrames}
          onItemClick={onItemClick}
        />
      ))}
    </div>
  );
};

// Use memo to prevent unnecessary rerenders
export default memo(TrackGroupComponent);
